import { ElasticSearchResponse, FaqCategory, FaqCategoryDocument } from '@shared/services/elastic-search/models';

export const faqCategoriesSerializer = (faqCategories: ElasticSearchResponse<FaqCategoryDocument>): FaqCategory[] =>
  faqCategories.hits.hits.map((faqCategory) => {
    const source = faqCategory._source;
    return {
      name: source.tag_term_name?.[0] ?? '',
    };
  });
